import { Button, Card, Form, Select, Spin } from 'antd';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";
import SubList from "../../components/SubList";

// These three are rendered as a linked Asset Type -> Sub Type -> Model cascade
// below, so they are skipped by the generic field loop.
const CASCADE_FIELDS = ['assetType', 'equipmentSubType', 'assetModel'];

class Create extends React.Component {

  state = { assetTypeId: undefined, subTypeId: undefined };

  componentDidMount() {
    const { match, fetch, data } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    this.syncCascadeFromData(data);
  }

  componentWillReceiveProps(nextProps) {
    // Edit data arrives asynchronously; seed the cascade ids from it so the
    // dependent selects unlock and filter to the saved values.
    if (nextProps.data !== this.props.data) {
      this.syncCascadeFromData(nextProps.data);
    }
  }

  idOf = (v) => (v && (v._id || v)) || undefined;

  syncCascadeFromData = (data) => {
    if (!data) return;
    const assetTypeId = this.idOf(data.assetType);
    const subTypeId = this.idOf(data.equipmentSubType);
    if (assetTypeId || subTypeId) {
      this.setState({ assetTypeId, subTypeId });
    }
  };

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  // Asset Type -> Sub Type -> Model. Options are filtered client-side from the
  // lists the schema already returns (each sub-type carries its populated
  // assetType, each model its populated assetSubType), so no extra API calls.
  renderCascade = () => {
    const { getFieldDecorator } = this.props.form;
    const { filters } = this.props;
    const data = this.props.data || {};
    const { assetTypeId, subTypeId } = this.state;

    const optionsOf = (key) => (filters[key] && filters[key].data && filters[key].data.data) || [];
    const types = optionsOf('assetType');
    const subTypes = optionsOf('equipmentSubType').filter(s => this.idOf(s.assetType) === assetTypeId);
    const models = optionsOf('assetModel').filter(m => this.idOf(m.assetSubType) === subTypeId);

    return [
      <Form.Item key="assetType" label="Asset Type">
        {getFieldDecorator('assetType', { initialValue: this.idOf(data.assetType) })(
          <Select
            allowClear
            showSearch
            optionFilterProp="children"
            placeholder="Please select"
            onChange={(v) => {
              // Changing the type invalidates the chosen sub-type and model.
              this.setState({ assetTypeId: v, subTypeId: undefined });
              this.props.form.setFieldsValue({ equipmentSubType: undefined, assetModel: undefined });
            }}
          >
            {types.map(t => <Select.Option key={t._id} value={t._id}>{t.name}</Select.Option>)}
          </Select>
        )}
      </Form.Item>,
      <Form.Item key="equipmentSubType" label="Sub Type">
        {getFieldDecorator('equipmentSubType', { initialValue: this.idOf(data.equipmentSubType) })(
          <Select
            allowClear
            showSearch
            optionFilterProp="children"
            disabled={!assetTypeId}
            placeholder={assetTypeId ? 'Please select' : 'Select an asset type first'}
            onChange={(v) => {
              this.setState({ subTypeId: v });
              this.props.form.setFieldsValue({ assetModel: undefined });
            }}
          >
            {subTypes.map(s => <Select.Option key={s._id} value={s._id}>{s.name}</Select.Option>)}
          </Select>
        )}
      </Form.Item>,
      <Form.Item key="assetModel" label="Model">
        {getFieldDecorator('assetModel', { initialValue: this.idOf(data.assetModel) })(
          <Select
            allowClear
            showSearch
            optionFilterProp="children"
            disabled={!subTypeId}
            placeholder={subTypeId ? 'Please select' : 'Select a sub type first'}
          >
            {models.map(m => <Select.Option key={m._id} value={m._id}>{m.name}</Select.Option>)}
          </Select>
        )}
      </Form.Item>
    ];
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form } = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if (CASCADE_FIELDS.indexOf(item) !== -1) {
                return null;
              }
              if (filters[item].type === 'Array' && filters[item].schema) {
                return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource} />
              } else {
                if (this.props.title === 'CREATE' && item !== 'voucherNo')
                  return getFormFieldByType(filters, item, getFieldDecorator, data, { title: title, resource })
                else if (this.props.title === 'EDIT')
                  return getFormFieldByType(filters, item, getFieldDecorator, data, { title: title, resource })
              }
            })}

            {this.renderCascade()}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
